// extracted by mini-css-extract-plugin
module.exports = {"container":"SortWeight_container__3oiCp"};